import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../base-components/Footer";
import Header from "../base-components/Header";

const Layout: React.FC = () => (
  <div className="flex flex-col min-h-screen">
    {/* Header */}
    <Header />

    {/* Main content */}
    <main className="flex-1 relative z-5 -mt-[35rem] md:-mt-[25rem]">
      <Outlet />
    </main>

    {/* Footer */}
    <Footer />
  </div>
);

export default Layout;
